import * as React from "react";
const WidgetIcon2 = (props) => (
  <svg
    width={41}
    height={39}
    viewBox="0 0 41 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.7648 18.7203L12.9354 9.20839H17.0365L20.2071 18.7203L29.719 21.8909V25.992L20.2071 29.1626L17.0365 38.6745H12.9354L9.7648 29.1626L0.25293 25.992V21.8909L9.7648 18.7203ZM14.986 16.7271L13.5241 21.1126L12.1571 22.4796L7.7716 23.9414L12.1571 25.4033L13.5241 26.7703L14.986 31.1558L16.4478 26.7703L17.8148 25.4033L22.2003 23.9414L17.8148 22.4796L16.4478 21.1126L14.986 16.7271Z"
      fill="#B1B1B1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.3611 5.89462L31.0474 0.835938H33.508L35.1942 5.89462L40.2529 7.58085V10.0415L35.1942 11.7277L33.508 16.7864H31.0474L29.3611 11.7277L24.3025 10.0415V7.58085L29.3611 5.89462Z"
      fill="#B1B1B1"
    />
  </svg>
);
export default WidgetIcon2;
